/*
 * ed-carousel.js — carrusel genérico de imágenes (fade) con flechas, puntos y
 * auto-rotación. Usado en editorial-split (sección de la fundación).
 * Pausa al hover/focus. Respeta prefers-reduced-motion.
 */
if (!customElements.get('ed-carousel')) {
  customElements.define(
    'ed-carousel',
    class EdCarousel extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.slides = Array.from(this.querySelectorAll('.ed-carousel__slide'));
        this.dots = Array.from(this.querySelectorAll('.ed-carousel__dot'));
        this.index = 0;
        if (this.slides.length < 2) return;

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = (parseInt(this.dataset.speed, 10) || 6) * 1000;

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      go(i, manual) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.slides.forEach((s, idx) => {
          const active = idx === this.index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((d, idx) => d.classList.toggle('is-active', idx === this.index));
        if (manual) this.restart();
      }

      start() {
        if (!this.autoplay || this.reduce || this.slides.length < 2) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
      }

      restart() {
        this.stop();
        this.start();
      }
    }
  );
}
